import type {PropertyType} from 'types/propertyTypes'

type AddressObject = {
  zipcode?: string
  state?: string
  city?: string
}

export type NormalizedAddress = {
  street?: string
} & AddressObject

export function normalizeAddress(addressLine1?: string, addressLine4?: string): NormalizedAddress {
  const {city, state, zipcode} = addressLine4
    ? getCityStateZip(addressLine4)
    : ({} as AddressObject)

  return {
    street: addressLine1,
    city,
    state,
    zipcode
  }
}

export const getAddressLine4 = (property: PropertyType) => {
  const address = (property && property.address) || {} // property.address sometimes is null
  return (
    address.displayAddressLine4 ||
    `${address.city || ''}${address.city ? ', ' : ''}${address.state || ''} ${
      // @ts-ignore address only have zip, no zipcode
      address.zipcode || ''
    }`
  ).trim()
}

function getCityStateZip(cityStateZipString: string): AddressObject {
  const doubleSpace = /\s\s+/g
  const comma = /[,]/g
  const addressArray = cityStateZipString.replace(doubleSpace, ' ').replace(comma, '').split(' ')

  return {
    zipcode: addressArray.pop(),
    state: addressArray.pop(),
    city: addressArray.join(' ')
  }
}
